(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("nepalify", [], factory);
	else if(typeof exports === 'object')
		exports["nepalify"] = factory();
	else
		root["nepalify"] = factory();
})(window, function() {
return 